import React from "react";

const Error = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h1 className="display-1 fw-bold">404</h1>
        <p className="fs-3">
          {" "}
          <span className="text-danger">Heyy! </span> Sayfa Bulunamadı.
        </p>
        <p className="lead">Aradığınız Sayfa Mevcut Değil.</p>
        <a href="/home" className="btn btn-primary">
          Ana Sayfa
        </a>
      </div>
    </div>
  );
};

export default Error;
